import { render } from "./PacmanLoader.vue?vue&type=template&id=2fb29d49&scoped=true"
import script from "./PacmanLoader.vue?vue&type=script&lang=js"
export * from "./PacmanLoader.vue?vue&type=script&lang=js"

import "./PacmanLoader.vue?vue&type=style&index=0&id=2fb29d49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb29d49"]])

export default __exports__